import type { HttpErrorResponse } from '@angular/common/http';

const DETAIL_MAX_LENGTH = 500;

/** Flattens a failed request into one technical line: status, the API exception message, then the transport message. */
export function describeError(error: unknown): string
{
    if (!error) { return ''; }

    const http = error as HttpErrorResponse;

    const parts = [
        typeof http.status === 'number' && http.status ? `HTTP ${ http.status }` : '',
        readExceptionMessage(http.error),
        typeof http.message === 'string' ? http.message.trim() : '',
        typeof error === 'string' ? error.trim() : '',
    ].filter(Boolean);

    const unique: string[] = [];
    for (const part of parts)
    {
        if (unique.indexOf(part) < 0) { unique.push(part); }
    }

    return unique.join(' — ').slice(0, DETAIL_MAX_LENGTH);
}

/** The `message` a NestJS exception filter puts in the body, which the transport message never carries. */
function readExceptionMessage(body: unknown): string
{
    if (typeof body === 'string') { return body.trim(); }
    if (!body || typeof body !== 'object') { return ''; }

    const record = body as { message?: unknown; error?: unknown; };
    const value = record.message ?? record.error;

    if (Array.isArray(value))
    {
        return value.filter(item => typeof item === 'string').join('; ').trim();
    }

    return typeof value === 'string' ? value.trim() : '';
}
